import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TaskHistoryApi, TaskHistoryRequest, TaskHistoryResponse } from '../task-history-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class TaskHistoryApiImpl extends GuestAwareHttpService implements TaskHistoryApi {
    async getTaskHistory(request: TaskHistoryRequest): Promise<TaskHistoryResponse> {
        const res = await this.getWithGuestSupport<TaskHistoryResponse>(
            'task/history',
            {
                task_id: request.task_id,
            }
        );
        return res;
    }
}
